module.exports = __webpack_public_path__ + "static/media/mmm-provider-home.5845e122.svg";